// AUTO-GENERATED FILE - DO NOT EDIT
// Run `bun run genTeeth` instead.
/* eslint-disable */
import {
  ToothModelHollowHingedEmbossedNoneGingivaSVG,
  ToothModelHollowHingedEmbossedNoneNoneSVG,
  ToothModelHollowHingedEmbossedPalateGingivaSVG,
  ToothModelHollowHingedEmbossedPalateNoneSVG,
  ToothModelHollowHingedEngravedNoneGingivaSVG,
  ToothModelHollowHingedEngravedNoneNoneSVG,
  ToothModelHollowHingedEngravedPalateGingivaSVG,
  ToothModelHollowHingedEngravedPalateNoneSVG,
  ToothModelHollowHingedNoneNoneGingivaSVG,
  ToothModelHollowHingedNoneNoneNoneSVG,
  ToothModelHollowHingedNonePalateGingivaSVG,
  ToothModelHollowHingedNonePalateNoneSVG,
  ToothModelHollowNoneEmbossedNoneGingivaSVG,
  ToothModelHollowNoneEmbossedNoneNoneSVG,
  ToothModelHollowNoneEmbossedPalateGingivaSVG,
  ToothModelHollowNoneEmbossedPalateNoneSVG,
  ToothModelHollowNoneEngravedNoneGingivaSVG,
  ToothModelHollowNoneEngravedNoneNoneSVG,
  ToothModelHollowNoneEngravedPalateGingivaSVG,
  ToothModelHollowNoneEngravedPalateNoneSVG,
  ToothModelHollowNoneNoneNoneGingivaSVG,
  ToothModelHollowNoneNoneNoneNoneSVG,
  ToothModelHollowNoneNonePalateGingivaSVG,
  ToothModelHollowNoneNonePalateNoneSVG,
  ToothModelHollowPillarsEmbossedNoneGingivaSVG,
  ToothModelHollowPillarsEmbossedNoneNoneSVG,
  ToothModelHollowPillarsEmbossedPalateGingivaSVG,
  ToothModelHollowPillarsEmbossedPalateNoneSVG,
  ToothModelHollowPillarsEngravedNoneGingivaSVG,
  ToothModelHollowPillarsEngravedNoneNoneSVG,
  ToothModelHollowPillarsEngravedPalateGingivaSVG,
  ToothModelHollowPillarsEngravedPalateNoneSVG,
  ToothModelHollowPillarsNoneNoneGingivaSVG,
  ToothModelHollowPillarsNoneNoneNoneSVG,
  ToothModelHollowPillarsNonePalateGingivaSVG,
  ToothModelHollowPillarsNonePalateNoneSVG,
  ToothModelSolidHingedEmbossedNoneGingivaSVG,
  ToothModelSolidHingedEmbossedNoneNoneSVG,
  ToothModelSolidHingedEmbossedPalateGingivaSVG,
  ToothModelSolidHingedEmbossedPalateNoneSVG,
  ToothModelSolidHingedEngravedNoneGingivaSVG,
  ToothModelSolidHingedEngravedNoneNoneSVG,
  ToothModelSolidHingedEngravedPalateGingivaSVG,
  ToothModelSolidHingedEngravedPalateNoneSVG,
  ToothModelSolidHingedNoneNoneGingivaSVG,
  ToothModelSolidHingedNoneNoneNoneSVG,
  ToothModelSolidHingedNonePalateGingivaSVG,
  ToothModelSolidHingedNonePalateNoneSVG,
  ToothModelSolidNoneEmbossedNoneGingivaSVG,
  ToothModelSolidNoneEmbossedNoneNoneSVG,
  ToothModelSolidNoneEmbossedPalateGingivaSVG,
  ToothModelSolidNoneEmbossedPalateNoneSVG,
  ToothModelSolidNoneEngravedNoneGingivaSVG,
  ToothModelSolidNoneEngravedNoneNoneSVG,
  ToothModelSolidNoneEngravedPalateGingivaSVG,
  ToothModelSolidNoneEngravedPalateNoneSVG,
  ToothModelSolidNoneNoneNoneGingivaSVG,
  ToothModelSolidNoneNoneNoneNoneSVG,
  ToothModelSolidNoneNonePalateGingivaSVG,
  ToothModelSolidNoneNonePalateNoneSVG,
  ToothModelSolidPillarsEmbossedNoneGingivaSVG,
  ToothModelSolidPillarsEmbossedNoneNoneSVG,
  ToothModelSolidPillarsEmbossedPalateGingivaSVG,
  ToothModelSolidPillarsEmbossedPalateNoneSVG,
  ToothModelSolidPillarsEngravedNoneGingivaSVG,
  ToothModelSolidPillarsEngravedNoneNoneSVG,
  ToothModelSolidPillarsEngravedPalateGingivaSVG,
  ToothModelSolidPillarsEngravedPalateNoneSVG,
  ToothModelSolidPillarsNoneNoneGingivaSVG,
  ToothModelSolidPillarsNoneNoneNoneSVG,
  ToothModelSolidPillarsNonePalateGingivaSVG,
  ToothModelSolidPillarsNonePalateNoneSVG
} from '@/components/Icon/Teeth';

// Mapping from file name to component.
export const toothComponents: Record<string, React.FC<React.SVGProps<SVGSVGElement> & { title?: string }>> = {
  "hollow-hinged-embossed-none-gingiva.svg": ToothModelHollowHingedEmbossedNoneGingivaSVG,
  "hollow-hinged-embossed-none-none.svg": ToothModelHollowHingedEmbossedNoneNoneSVG,
  "hollow-hinged-embossed-palate-gingiva.svg": ToothModelHollowHingedEmbossedPalateGingivaSVG,
  "hollow-hinged-embossed-palate-none.svg": ToothModelHollowHingedEmbossedPalateNoneSVG,
  "hollow-hinged-engraved-none-gingiva.svg": ToothModelHollowHingedEngravedNoneGingivaSVG,
  "hollow-hinged-engraved-none-none.svg": ToothModelHollowHingedEngravedNoneNoneSVG,
  "hollow-hinged-engraved-palate-gingiva.svg": ToothModelHollowHingedEngravedPalateGingivaSVG,
  "hollow-hinged-engraved-palate-none.svg": ToothModelHollowHingedEngravedPalateNoneSVG,
  "hollow-hinged-none-none-gingiva.svg": ToothModelHollowHingedNoneNoneGingivaSVG,
  "hollow-hinged-none-none-none.svg": ToothModelHollowHingedNoneNoneNoneSVG,
  "hollow-hinged-none-palate-gingiva.svg": ToothModelHollowHingedNonePalateGingivaSVG,
  "hollow-hinged-none-palate-none.svg": ToothModelHollowHingedNonePalateNoneSVG,
  "hollow-none-embossed-none-gingiva.svg": ToothModelHollowNoneEmbossedNoneGingivaSVG,
  "hollow-none-embossed-none-none.svg": ToothModelHollowNoneEmbossedNoneNoneSVG,
  "hollow-none-embossed-palate-gingiva.svg": ToothModelHollowNoneEmbossedPalateGingivaSVG,
  "hollow-none-embossed-palate-none.svg": ToothModelHollowNoneEmbossedPalateNoneSVG,
  "hollow-none-engraved-none-gingiva.svg": ToothModelHollowNoneEngravedNoneGingivaSVG,
  "hollow-none-engraved-none-none.svg": ToothModelHollowNoneEngravedNoneNoneSVG,
  "hollow-none-engraved-palate-gingiva.svg": ToothModelHollowNoneEngravedPalateGingivaSVG,
  "hollow-none-engraved-palate-none.svg": ToothModelHollowNoneEngravedPalateNoneSVG,
  "hollow-none-none-none-gingiva.svg": ToothModelHollowNoneNoneNoneGingivaSVG,
  "hollow-none-none-none-none.svg": ToothModelHollowNoneNoneNoneNoneSVG,
  "hollow-none-none-palate-gingiva.svg": ToothModelHollowNoneNonePalateGingivaSVG,
  "hollow-none-none-palate-none.svg": ToothModelHollowNoneNonePalateNoneSVG,
  "hollow-pillars-embossed-none-gingiva.svg": ToothModelHollowPillarsEmbossedNoneGingivaSVG,
  "hollow-pillars-embossed-none-none.svg": ToothModelHollowPillarsEmbossedNoneNoneSVG,
  "hollow-pillars-embossed-palate-gingiva.svg": ToothModelHollowPillarsEmbossedPalateGingivaSVG,
  "hollow-pillars-embossed-palate-none.svg": ToothModelHollowPillarsEmbossedPalateNoneSVG,
  "hollow-pillars-engraved-none-gingiva.svg": ToothModelHollowPillarsEngravedNoneGingivaSVG,
  "hollow-pillars-engraved-none-none.svg": ToothModelHollowPillarsEngravedNoneNoneSVG,
  "hollow-pillars-engraved-palate-gingiva.svg": ToothModelHollowPillarsEngravedPalateGingivaSVG,
  "hollow-pillars-engraved-palate-none.svg": ToothModelHollowPillarsEngravedPalateNoneSVG,
  "hollow-pillars-none-none-gingiva.svg": ToothModelHollowPillarsNoneNoneGingivaSVG,
  "hollow-pillars-none-none-none.svg": ToothModelHollowPillarsNoneNoneNoneSVG,
  "hollow-pillars-none-palate-gingiva.svg": ToothModelHollowPillarsNonePalateGingivaSVG,
  "hollow-pillars-none-palate-none.svg": ToothModelHollowPillarsNonePalateNoneSVG,
  "solid-hinged-embossed-none-gingiva.svg": ToothModelSolidHingedEmbossedNoneGingivaSVG,
  "solid-hinged-embossed-none-none.svg": ToothModelSolidHingedEmbossedNoneNoneSVG,
  "solid-hinged-embossed-palate-gingiva.svg": ToothModelSolidHingedEmbossedPalateGingivaSVG,
  "solid-hinged-embossed-palate-none.svg": ToothModelSolidHingedEmbossedPalateNoneSVG,
  "solid-hinged-engraved-none-gingiva.svg": ToothModelSolidHingedEngravedNoneGingivaSVG,
  "solid-hinged-engraved-none-none.svg": ToothModelSolidHingedEngravedNoneNoneSVG,
  "solid-hinged-engraved-palate-gingiva.svg": ToothModelSolidHingedEngravedPalateGingivaSVG,
  "solid-hinged-engraved-palate-none.svg": ToothModelSolidHingedEngravedPalateNoneSVG,
  "solid-hinged-none-none-gingiva.svg": ToothModelSolidHingedNoneNoneGingivaSVG,
  "solid-hinged-none-none-none.svg": ToothModelSolidHingedNoneNoneNoneSVG,
  "solid-hinged-none-palate-gingiva.svg": ToothModelSolidHingedNonePalateGingivaSVG,
  "solid-hinged-none-palate-none.svg": ToothModelSolidHingedNonePalateNoneSVG,
  "solid-none-embossed-none-gingiva.svg": ToothModelSolidNoneEmbossedNoneGingivaSVG,
  "solid-none-embossed-none-none.svg": ToothModelSolidNoneEmbossedNoneNoneSVG,
  "solid-none-embossed-palate-gingiva.svg": ToothModelSolidNoneEmbossedPalateGingivaSVG,
  "solid-none-embossed-palate-none.svg": ToothModelSolidNoneEmbossedPalateNoneSVG,
  "solid-none-engraved-none-gingiva.svg": ToothModelSolidNoneEngravedNoneGingivaSVG,
  "solid-none-engraved-none-none.svg": ToothModelSolidNoneEngravedNoneNoneSVG,
  "solid-none-engraved-palate-gingiva.svg": ToothModelSolidNoneEngravedPalateGingivaSVG,
  "solid-none-engraved-palate-none.svg": ToothModelSolidNoneEngravedPalateNoneSVG,
  "solid-none-none-none-gingiva.svg": ToothModelSolidNoneNoneNoneGingivaSVG,
  "solid-none-none-none-none.svg": ToothModelSolidNoneNoneNoneNoneSVG,
  "solid-none-none-palate-gingiva.svg": ToothModelSolidNoneNonePalateGingivaSVG,
  "solid-none-none-palate-none.svg": ToothModelSolidNoneNonePalateNoneSVG,
  "solid-pillars-embossed-none-gingiva.svg": ToothModelSolidPillarsEmbossedNoneGingivaSVG,
  "solid-pillars-embossed-none-none.svg": ToothModelSolidPillarsEmbossedNoneNoneSVG,
  "solid-pillars-embossed-palate-gingiva.svg": ToothModelSolidPillarsEmbossedPalateGingivaSVG,
  "solid-pillars-embossed-palate-none.svg": ToothModelSolidPillarsEmbossedPalateNoneSVG,
  "solid-pillars-engraved-none-gingiva.svg": ToothModelSolidPillarsEngravedNoneGingivaSVG,
  "solid-pillars-engraved-none-none.svg": ToothModelSolidPillarsEngravedNoneNoneSVG,
  "solid-pillars-engraved-palate-gingiva.svg": ToothModelSolidPillarsEngravedPalateGingivaSVG,
  "solid-pillars-engraved-palate-none.svg": ToothModelSolidPillarsEngravedPalateNoneSVG,
  "solid-pillars-none-none-gingiva.svg": ToothModelSolidPillarsNoneNoneGingivaSVG,
  "solid-pillars-none-none-none.svg": ToothModelSolidPillarsNoneNoneNoneSVG,
  "solid-pillars-none-palate-gingiva.svg": ToothModelSolidPillarsNonePalateGingivaSVG,
  "solid-pillars-none-palate-none.svg": ToothModelSolidPillarsNonePalateNoneSVG,
};